import React from 'react';
import {connect} from 'react-redux';
import {deepClone, sortBy} from 'lodash';

// local imports
import api from '../../../store/api'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import validators from "../../../utils/forms/validators";

import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import FormModal from "../../theme/modals/FormModal";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import {pullStates} from "../../../store/calls";
import * as preconfiguredInputs from "../../../utils/forms/preconfiguredInputs";
import formatters from "../../../utils/forms/formatters";


class PaceProgramScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            displayedData: [],
            dataPullLimit: 100,
            dataPullOffset: 0,

            // edit and delete
            editModalOpen: false,
            deleteModalOpen: false,
            editingInstance: null,

            mode: 'improvements', // can also be categories

            improvementCategories: [],

            categoryFilter: null,
            nameFilter: null,
        }




        this.createEditInputs = [
            {
                type: 'text',
                label: "Name*",
                dataKey: "name",
                ...validators.isStringOfMinLength(3)
            },
            {
                type: 'textarea',
                label: "Description",
                dataKey: "description",
            },
            {
                type: 'select',
                label: "State*",
                dataKey: "state",
                options: sortBy(this.props.states, ['name']).map(d => ({value: d.id, display: d.name})),
                ...validators.exists,
            },
            {
                type: 'text',
                label: "Program Minimum",
                subLabel: "The smallest project this program will accept, in dollars",
                dataKey: "program_minimum",
                ...validators.isNumber,
                ...formatters.USDCurrency,
            },
            {
                type: 'text',
                label: "Program Maximum",
                subLabel: "The largest project this program will accept, in dollars",
                dataKey: "program_maximum",
                ...validators.isNumber,
                ...formatters.USDCurrency,
            },
            {
                type: 'textarea',
                label: "Property Tax Delinquency Policy",
                dataKey: "prop_tax_delinquency_policy",
            },
            {
                type: 'textarea',
                label: "Bankruptcy Policy",
                dataKey: "bankruptcy_policy",
            },
            {
                type: 'text',
                label: "Program Fee Tier 1",
                dataKey: "program_fee_tier_1",
                // ...validators.isNumber,
                otherInputs: [
                    {
                        ...preconfiguredInputs.flatFeeChargeTypeSelect,
                        dataKey: "program_fee_tier_1_charge_type",
                        label: "Charge Type",
                        ...validators.requiredIf('program_fee_tier_1')
                    },
                    {
                        type: "text",
                        dataKey: "program_fee_tier_1_cost_ceiling",
                        label: "Tier 1 Cieling (leave blank if none)",
                        placeholder: "tier cieling",
                        // ...validators.isNumber,
                        ...formatters.USDCurrency
                    }
                ]
            },
            {
                type: 'text',
                label: "Program Fee Tier 2",
                dataKey: "program_fee_tier_2",
                // ...validators.isNumber,
                otherInputs: [
                    {
                        ...preconfiguredInputs.flatFeeChargeTypeSelect,
                        dataKey: "program_fee_tier_2_charge_type",
                        label: "Charge Type",
                        ...validators.requiredIf('program_fee_tier_2')
                    },
                    {
                        type: "text",
                        dataKey: "program_fee_tier_2_cost_ceiling",
                        label: "Tier 2 Cieling (leave blank if none)",
                        placeholder: "tier cieling",
                        // ...validators.isNumber,
                        ...formatters.USDCurrency
                    }
                ]
            },
            {
                type: 'text',
                label: "Program Fee Tier 3",
                dataKey: "program_fee_tier_3",
                // ...validators.isNumber,
                otherInputs: [
                    {
                        ...preconfiguredInputs.flatFeeChargeTypeSelect,
                        dataKey: "program_fee_tier_3_charge_type",
                        label: "Charge Type",
                        ...validators.requiredIf('program_fee_tier_3')
                    },
                ]
            },
            {
                type: 'text',
                label: "Program Fee Min/Max",
                dataKey: "program_fee_minimum",
                placeholder: "Minimum",
                // ...validators.isNumber,
                ...formatters.USDCurrency,
                otherInputs: [
                    {
                        type: "text",
                        dataKey: "program_fee_maximum",
                        placeholder: "Maximum",
                        // ...validators.isNumber,
                        ...formatters.USDCurrency
                    },
                ]
            },
            {
                type: 'select',
                label:  "Program Fee Cost Basis",
                dataKey: 'program_fee_cost_basis',
                options: [
                    {
                        value: "financed_amount",
                        display: "Financed Amount"
                    },
                    {
                        value: "cost_of_improvements",
                        display: "Cost of Improvements"
                    },
                ]
            },
            {
                type: 'text',
                label: "Program Annual Fee",
                dataKey: "annual_fee",
                // ...validators.isNumber,
                otherInputs: [
                    {
                        ...preconfiguredInputs.flatFeeChargeTypeSelect,
                        dataKey: "annual_fee_type",
                        label: "Charge Type",
                        ...validators.requiredIf('annual_fee')
                    },
                ]
            },
            {
                type: 'text',
                label: "Proof of Saving or Efficiency Policy",
                dataKey: "proof_of_savings_req",
            },
            {
                ...preconfiguredInputs.nullBooleanSelect,
                label: "Do Funders Bill Directly",
                dataKey: "allow_direct_funder_billing",
            },
            {
                type: 'text',
                label: "First Payment Due Date (M/DD, eg, 3/01) *",
                dataKey: "first_payment_due_date",
                // ...validators.isStringOfMinLength(4),
                ...formatters.date("Mdd",  "LLLL dd"),
            },
            {
                type: 'text',
                label: "State or County Fiscal Year End (M/DD, eg, 3/01) *",
                dataKey: "fiscal_year_end",
                // ...validators.isStringOfMinLength(4),
                ...formatters.date("Mdd",  "LLLL dd"),
            },
            {
                type: 'text',
                label: "Number of payments billed per year",
                dataKey: "prop_tax_annual_payment_count",
                ...validators.isNumber
            },
            {
                type: 'text',
                label: "Min Number of Units in Commercial Multi Family Projects*",
                dataKey: "multi_family_min_units",
                ...validators.isNumber
            },
            {
                ...preconfiguredInputs.nullBooleanSelect,
                label: "Lender Consent Required",
                dataKey: "lender_consent_req",
            },
            {
                ...preconfiguredInputs.nullBooleanSelect,
                label: "Accept Refinance",
                dataKey: "refi_ok",
            },
            {
                type: "text",
                label: "Maximum aging (in years) of an authorized improvement to be refinanced",
                dataKey: "refi_lookback_period",
                ...validators.isNumber
            },
            {
                ...preconfiguredInputs.nullBooleanSelect,
                label: "Is a permitted building required on the parcel to qualify?",
                dataKey: "permitted_building_required",
            },
            {
                type: "textarea",
                label: "Other Notes",
                dataKey: "other_notes",
            }

        ]

    }

    componentDidMount() {
        this.getData();
        pullStates();

    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    getData = (xtraParams = {}) => {
        let params = {
            limit: this.state.dataPullLimit,
            offset: this.state.dataPullOffset,
            searchVal: this.state.nameFilter,
            category: this.state.categoryFilter,
            ...xtraParams
        }

        // i need to be able to query specifically for the intended pace programs
        toggleGlobalLoader(true);
        return api.get('/pace-programs/', params)
            .then(res => {
                let results = res.data.results || [];
                // filter to permissions
                if (!this.props.tokenData.admin) {
                    results = results.filter(d => this.props.tokenData.pp_adm.includes(d.id))
                }
                results = results.map(d => ({...d, '_html_name': <a className='has-text-primary' href={`/admin/pace-programs/${d.id}`}>{d.name}</a>}))
                this.setState({displayedData: sortBy(results, ['name'])});
                toggleGlobalLoader(false);
            })
            .catch((err) => {
                console.log(err)
                addErrorAlert('Failed to get pace program data.')
            })
    }

    handleLimitChange = (val) => {
        this.setState({dataPullLimit: val}, this.getData)
    }

    handleOffsetChange = (val) => {
        this.setState({dataPullOffset: val}, this.getData)
    }

    populateInputsWithValues = () => {
        return this.createEditInputs.map(d => ({
            ...d,
            value: this.state.editingInstance ? this.state.editingInstance[d.dataKey] : null
        }))

    }

    handleDeleteRequest = () => {
        api.patch(`/pace-programs/${this.state.editingInstance.id}/`, {is_active: 0})
            .then(() => this.getData())
            .catch(err =>  addErrorAlert('Deletion Failed.'))
            .finally(() => this.setState({deleteModalOpen: false, editingInstance: null}))
    }

    handleCreateOrUpdateRequest = (data) => {
        let promise;
        if (this.state.editingInstance) {
            promise = () => api.patch(`/pace-programs/${this.state.editingInstance.id}/`, data)
        } else {
            promise = () => api.post('/pace-programs/', data)
        }

        return promise()
            .then(() => this.getData())
            .catch(err => addErrorAlert('Update Failed. Please try again.'))
            .finally(() => this.setState({editModalOpen: false, editingInstance: null}))
    }


    handleSearch = (val) => {
        this.setState({nameFilter: val},
            this.getData
        )
    }

    buildFilterOptions = () => {
        return [
            // {
            //     options: [{value: null, display: 'None'},
            //         ...sortBy(this.state.improvementCategories, ['name']).map(d => ({value: d.id, display: d.name}))
            //     ],
            //     value: this.state.categoryFilter, //default ca
            //     onChange: (val) => this.setState({categoryFilter: val}, this.getData)
            // }
        ]
    }


    render() {
        return (
            <AdminWrapper>
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <h2 className="title is-2">Manage Pace Programs</h2>
                                </div>
                            </div>
                            <div className="level-right">
                                {this.props.tokenData.admin &&
                                    <div className="level-item">
                                        <button
                                            className='button is-link'
                                            onClick={() => this.setState({editModalOpen: true})}
                                        >+ Add Program
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                        <PaginatedTable
                            className="is-fullwidth is-hoverable"
                            data={this.state.displayedData}
                            columns={['name', 'description', 'state', 'program_minimum']}
                            pullLimit={this.state.dataPullLimit}
                            handleLimitChange={this.handleLimitChange}
                            pullOffset={this.state.dataPullOffset}
                            handleOffsetChange={this.handleOffsetChange}
                            handleSearch={this.handleSearch}
                            filterOptions={this.buildFilterOptions()}
                            actions={[
                            ]}
                        />
                    </div>
                </div>

                <FormModal
                    title={this.props.editingInstance ? this.props.editingInstance.name : 'Create a new PACE Program'}
                    visible={this.state.editModalOpen}
                    inputs={this.populateInputsWithValues()}
                    disableAutocomplete
                    onSubmit={this.handleCreateOrUpdateRequest}
                    onCancel={() => this.setState({editModalOpen: false, editingInstance: null})}
                    otherButtons={[<button className="button" onClick={() => null}>Add Another</button>]}
                />
                <ConfirmModal
                    type="warning"
                    visible={this.state.deleteModalOpen && this.state.editingInstance}
                    prompt={!!this.state.editingInstance && `Are you sure you want to delete improvement ${this.state.editingInstance.name}?`}
                    onCancel={() => this.setState({deleteModalOpen: false, editingInstance: null})}
                    onAccept={this.handleDeleteRequest}
                />


            </AdminWrapper>
        )
    }

}


const mapStateToProps = state => ({
    tokenData: state.user.decodedTokenData,
    states: state.states.data
})

export default connect(mapStateToProps)(PaceProgramScreen)


